import { LoadingSpinner, Text } from "@clipboard-health/ui-components";
import { isDefined } from "@clipboard-health/util-ts";
import { Stack } from "@mui/material";
import { useDefinedWorker } from "@src/appV2/Worker/useDefinedWorker";

import { Button } from "../../components/Button";
import { ProfileImage } from "../../WorkWithFriends/components/ProfileImage";

interface BadgeSmithCheckoutContentProps {
  profilePictureUrl: string | undefined;
  isLoading: boolean;
  isError: boolean;
  onRetry: () => void;
}

export function BadgeSmithCheckoutContent(props: BadgeSmithCheckoutContentProps) {
  const { profilePictureUrl, isLoading, isError, onRetry } = props;

  const worker = useDefinedWorker();

  if (isLoading) {
    return (
      <Stack height="100%" justifyContent="center" alignItems="center">
        <LoadingSpinner size="large" />
      </Stack>
    );
  }

  if (isError) {
    return (
      <Stack height="100%" justifyContent="center" alignItems="center" spacing={3}>
        <Text variant="body1" sx={{ textAlign: "center" }}>
          Failed to load profile photo. Please try again.
        </Text>
        <Button variant="outlined" size="medium" onClick={onRetry}>
          Retry
        </Button>
      </Stack>
    );
  }

  const hasProfilePicture = isDefined(profilePictureUrl);

  return (
    <Stack gap={6} paddingTop={8}>
      <ProfileImage
        size="large"
        firstName={worker.firstName ?? ""}
        lastName={worker.lastName ?? ""}
        src={profilePictureUrl}
      />
      <Stack gap={2} alignItems="flex-start">
        <Text bold variant="h6">
          {worker.firstName} {worker.lastName}
        </Text>
        <Text variant="body1">
          {hasProfilePicture
            ? "Your profile photo will be used for your badge. You can update it in the next step before ordering."
            : "You need a profile photo before ordering your badge. This photo will appear on your badge."}
        </Text>
      </Stack>
    </Stack>
  );
}
